import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'
import { storageLocal } from '@pureadmin/utils'
import type { userType } from '@/types/userStoreTypes'
import { CommonUtils } from '@/utils/commonUtils'
import { useUserStoreHook } from '@/store/modules/user'
import type { Directive, DirectiveBinding } from 'vue'
import { message } from '@/utils'
import router from '@/router'
export const sessionKey = 'user-info'
export const TokenKey = 'authorized-token'
import { useWebSocketStore } from '@/store/modules/websocket'
import { WebSocketEvent, CreditConsumptionType } from '@/types/constantsEnum'
import integralApi from '@/api/integralApi'
import { getBenefitValue } from '@/utils/commonUtils'
import { UserBenefitType } from '@/types/constantsEnum'
import { Code } from '@/config/httpCode'
import { useUserStoreHook } from '@/store/modules/user'
import { useIntegralStoreHook } from '@/store/modules/integral'
import { useDialog } from '@/utils/dialogUtils'

/** 获取`token` */
export function getToken(): DataInfo<string> {
  return Cookies.get(TokenKey)
    ? CommonUtils.getJSONObj(Cookies.get(TokenKey))
    : storageLocal().getItem(sessionKey)
}
/** 格式化token（jwt格式） */
export const formatToken = (token: string): string => {
  return 'Bearer ' + token
}
export async function setToken(data: DataInfo<string>) {
  try {
    const wsStore = useWebSocketStore()
    //  设置 cookie token
    const { token } = data
    const cookieString = CommonUtils.getJSON({ token })
    Cookies.set(TokenKey, cookieString)

    //  批量更新用户状态
    const userStore = useUserStoreHook()
    const userState: Partial<userType> = {
      id: data.id,
      avatar: data.avatar,
      nickname: data.nickname,
      extra: data.extra,
      username: data.username,
      inviteCode: data.inviteCode,
      roles: data.roles,
      tag: data.tag,
      token: data.token,
      type: data.type,
      isLogin: true,
      gender: data.gender,
      signature: data.signature,
      scoreDetail: {
        credit: 0, // 初始值，后面会更新
      },
    }

    // 批量设置用户信息
    Object.entries(userState).forEach(([key, value]) => {
      userStore.setUserData(key as keyof userType, value)
    })
    useUserStoreHook().updateScore()

    //  存储用户信息到本地
    storageLocal().setItem(sessionKey, userState)

    wsStore.sendMessage(CommonUtils.sendEventSocket(WebSocketEvent.UserEvent))

    // 获取重定向地址
    const redirect = router.currentRoute.value.query.redirect as string
    if (redirect) {
      // 有重定向地址则优先跳转
      router.push(decodeURIComponent(redirect))
    } else {
      // 没有重定向地址才跳转首页
      router.push('/')
    }
  } catch (error) {
    console.error('设置用户信息失败:', error)
    removeToken()
    throw new Error('设置用户信息失败')
  }
}

/** 删除`token`以及key值为`user-info`的session信息 */
export function removeToken() {
  Cookies.remove(TokenKey)
  storageLocal().removeItem(sessionKey)
}

/** 登陆密码和上传文件名加密 */
export const createSha256 = (data: string): string => {
  return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex).substring(0, 18)
}

export const auth: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const userStore = useUserStoreHook()

    // 点击处理函数
    const handleClick = async (e: Event) => {
      // 如果未登录，阻止事件冒泡和默认行为
      if (!userStore.isLogin) {
        e.preventDefault()
        e.stopPropagation()

        message.info('请先登录')
        // 记录当前路由，登录后返回
        console.log(router, 'router')
        const currentRoute = router.currentRoute.value.fullPath
        router.push(`/login?redirect=${encodeURIComponent(currentRoute)}`)
        return
      }

      // 已登录时不阻止事件传播
      if (binding.value && typeof binding.value === 'function') {
        binding.value(e)
      }
    }

    // 添加点击事件监听，使用捕获阶段
    el.addEventListener('click', handleClick, true)

    // 存储处理函数，以便后续移除
    ;(el as any).__authClick__ = handleClick
  },

  // 组件卸载时移除事件监听
  unmounted(el: HTMLElement) {
    if ((el as any).__authClick__) {
      el.removeEventListener('click', (el as any).__authClick__, true)
      delete (el as any).__authClick__
    }
  },
}
export const authIntegralCheck = (type: CreditConsumptionType) => {
  console.log(type, 'type')
  const userStore = useUserStoreHook()
  const integralConfig = useIntegralStoreHook().integralConfig
  const integral = integralConfig[type]
  const userIntegral = userStore.scoreDetail.credit
  const { showRechargeDialog } = useDialog()

  if (userIntegral < integral.count) {
    message.info('积分不足')
    showRechargeDialog()
    return false
  }
  return true
}
